(function () {
  const routes = {
    project: {
      label: 'Project inquiry',
      desk: 'David Jones',
      email: 'david.jones@roomwell.co.uk',
    },
    global: {
      label: 'Global accounts',
      desk: 'Sameer Chap',
      email: 'sameer.chap@roomwell.co.uk',
    },
    hilton: {
      label: 'Hilton approved vendor',
      desk: 'Hilton Program Desk',
      email: 'hilton.desk@roomwell.co.uk',
      hint: 'For Hilton approved program pricing, warranty support, or HSM enquiries. Include your property InnCode.',
    },
    accor: {
      label: 'Accor program',
      desk: 'Accor Program Desk',
      email: 'accor.desk@roomwell.co.uk',
    },
    distributor: {
      label: 'Distributor inquiry',
      desk: 'David Jones, Distribution',
      email: 'david.jones@roomwell.co.uk',
    },
    general: {
      label: 'General enquiry',
      desk: 'Roomwell Sales',
      email: 'sales@roomwell.co.uk',
      hint: 'General product and warranty enquiries. Our sales team will respond within 2 business hours.',
    },
  };

  function init(root) {
    const select = root.querySelector('[data-enquiry-type]');
    const routeDesk = root.querySelector('[data-route-desk]');
    const routeEmail = root.querySelector('[data-route-email]');
    const routeLabel = root.querySelector('[data-route-label]');
    const routeHint = root.querySelector('[data-route-hint]');
    const routeTo = root.querySelector('[data-route-to]');
    const routeDeskField = root.querySelector('[data-route-desk-field]');
    const routeTypeField = root.querySelector('[data-route-type-field]');
    const cards = root.querySelectorAll('[data-desk-card]');
    const noteHilton = root.querySelector('[data-note-hilton]');
    const noteHiltonRef = root.querySelector('[data-note-hilton-ref]');
    const form = root.querySelector('.contact-inquiry__form') || root.querySelector('#ContactInquiryForm');
    const propertyInput = root.querySelector('[data-property-input]');
    const messageInput = root.querySelector('[data-message-input]');
    const bodyField = root.querySelector('[data-body-field]');

    if (!select || !form) return;

    function setRoute(key) {
      const r = routes[key];
      if (!r) return;

      select.value = key;
      if (routeLabel) routeLabel.textContent = r.label;
      if (routeDesk) routeDesk.textContent = r.desk;
      if (routeEmail) {
        routeEmail.innerHTML =
          '<a href="mailto:' + r.email + '">' + r.email + '</a>';
      }
      if (routeHint) {
        routeHint.innerHTML = r.hint
          ? r.hint + ' Your enquiry goes to <strong>' + r.email + '</strong>'
          : 'This form will send your enquiry to <strong>' + r.email + '</strong>';
      }
      if (routeTo) routeTo.value = r.email;
      if (routeDeskField) routeDeskField.value = r.desk;
      if (routeTypeField) routeTypeField.value = r.label;

      cards.forEach((c) => {
        c.classList.toggle('is-selected', c.dataset.deskCard === key);
      });

      if (noteHilton) {
        noteHilton.hidden = key !== 'hilton';
      }
      if (noteHiltonRef) {
        noteHiltonRef.hidden = key === 'general' || key === 'hilton';
      }
    }

    select.addEventListener('change', () => setRoute(select.value));

    cards.forEach((card) => {
      card.addEventListener('click', () => setRoute(card.dataset.deskCard));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setRoute(card.dataset.deskCard);
        }
      });
    });

    form.addEventListener('submit', () => {
      const property = propertyInput ? propertyInput.value.trim() : '';
      const message = messageInput ? messageInput.value.trim() : '';
      const parts = [];

      if (property) {
        parts.push('Property / Project: ' + property);
      }
      if (message) {
        parts.push(message);
      }

      if (bodyField) {
        bodyField.value = parts.join('\n\n');
      }
    });

    setRoute(select.value || 'project');
  }

  document.querySelectorAll('[data-contact-inquiry]').forEach(init);
})();
